export var AssignmentStatus;

(function (AssignmentStatus) {
  AssignmentStatus["ACTIVE"] = "3";
  AssignmentStatus["DELETED"] = "4";
})(AssignmentStatus || (AssignmentStatus = {}));